import * as yup from "yup";
import { PairSmartPayFormValues } from "./types";

export const defaultFormValues: PairSmartPayFormValues = {
  pairCode: "",
  posRegisterName: "",
  posBusinessName: "",
  posVendorName: "",
  terminalId: "",
  paymentMethodId: "",
};

export const schema = yup.object().shape({
  pairCode: yup.string().required("Pair code is required"),
  posRegisterName: yup.string().required("POS Register Name is required"),
  posBusinessName: yup.string().required("POS Business Name is required"),
  posVendorName: yup.string().required("POS Vendor Name is required"),
  terminalId: yup.string().required("Terminal ID is required"),
  paymentMethodId: yup.string().required("Payment Method ID is required"),
});
